const items = [
  {
    title: "Bathroom Klasik Modern",
    style: "Marble Carrara",
    img: "https://customer-assets.emergentagent.com/job_ai-interior-viz-1/artifacts/kng796z0_kamar%20mandi%20AT%20Studio.png",
    span: "lg:col-span-7 lg:row-span-2 aspect-[4/3] lg:aspect-auto",
  },
  {
    title: "Apartemen BSD",
    style: "Minimalist",
    img: "https://images.pexels.com/photos/16951262/pexels-photo-16951262.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
    span: "lg:col-span-5 aspect-square",
  },
  {
    title: "Rumah Serpong",
    style: "Japandi",
    img: "https://images.pexels.com/photos/8251255/pexels-photo-8251255.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
    span: "lg:col-span-5 aspect-square",
  },
  {
    title: "Loft Modern",
    style: "Industrial Light",
    img: "https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    span: "lg:col-span-7 aspect-[16/10]",
  },
  {
    title: "Villa Premium",
    style: "Tropical Modern",
    img: "https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    span: "lg:col-span-12 aspect-[21/9]",
  },
];

export default function Gallery() {
  return (
    <section id="galeri" data-testid="gallery-section" className="relative py-24 lg:py-32 px-6 lg:px-12 bg-white">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row justify-between items-end mb-16 gap-6">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-sky-600 mb-4 font-semibold">Portofolio Pilihan</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter leading-tight text-slate-900">
              Karya yang sudah kami<br /><span className="italic text-sky-600">wujudkan.</span>
            </h2>
          </div>
          <p className="text-slate-600 max-w-md font-light">
            Setiap proyek dimulai dari foto sederhana — diakhiri dengan ruangan yang memukau.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          {items.map((it) => (
            <figure
              key={it.title}
              data-testid={`gallery-item-${it.title.replace(/\s+/g, "-").toLowerCase()}`}
              className={`group relative overflow-hidden rounded-2xl shadow-lg shadow-sky-100/60 ${it.span}`}
            >
              <img
                src={it.img}
                alt={it.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/10 to-transparent" />
              <figcaption className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-sky-300 mb-1 font-semibold">{it.style}</div>
                  <div className="font-display text-xl lg:text-2xl text-white">{it.title}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
